// useSharedState.ts
import { useState, useEffect, useCallback } from 'react';

export function getStorageSafe(): Storage {
  try { const ls = localStorage; const k='__t'+Math.random(); ls.setItem(k,'1'); ls.removeItem(k); return ls; }
  catch { return { getItem:()=>null, setItem:()=>{}, removeItem:()=>{}, clear:()=>{}, key:()=>null, length:0 } as any; }
}

export function useSharedState(key: string, initialValue: string) {
    const [value, setValue] = useState(() => {
        const savedValue = getStorageSafe().getItem(key);
        return savedValue !== null ? savedValue : initialValue;
    });

    // Update state, local storage, and broadcast a custom event for the same page
    const setStoredValue = useCallback((newValue: string) => {
        setValue(newValue);
        getStorageSafe().setItem(key, newValue);

        // Dispatch a custom event for same-page updates
        const customEvent = new CustomEvent("localStorageUpdated", {
            detail: { key, newValue },
        });
        window.dispatchEvent(customEvent);
    }, [key]);

    // Listen to storage events for cross-tab updates and custom events for same-page updates
    useEffect(() => {
        const handleStorageChange = (event: StorageEvent | CustomEvent) => {
            if ("key" in event && event.key === key) {
                setValue(event.newValue || initialValue);
            } else if ("detail" in event && event.detail.key === key) {
                setValue(event.detail.newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange as EventListener);
        window.addEventListener('localStorageUpdated', handleStorageChange as EventListener);

        return () => {
            window.removeEventListener('storage', handleStorageChange as EventListener);
            window.removeEventListener('localStorageUpdated', handleStorageChange as EventListener);
        };
    }, [key, initialValue]);

    return [value, setStoredValue] as const;
}
